import { fromJS } from 'immutable';
import {
  INIT_URL,
  RESET_PASSWORD_ERROR,
  RESET_PASSWORD_SUCCESS,
  SET_AUTH_DATA,
  SET_AUTH_USER,
  SIGNIN_USER_ERROR,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  UPDATE_CLIENT_USER_SUCCESS,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_COMPANY_SUCCESS,
  DISCONNECT_TELEGRAM_SUCCESS,
} from 'constants/ActionTypes';
import { getCookie, setCookie } from 'helpers/cookieHelpers';
import { AUTH_COOKIE } from 'constants/UtilConstants';

/**
 * TODO: Временно добавленная функция для поддержки старого формата токена
 * @returns {string|null|*}
 */
const getToken = () => {
  let token = getCookie(AUTH_COOKIE);
  if (!token || typeof token !== 'string') {
    return null;
  }

  if (token.includes('token') && token.includes('userId') && token.includes('type')) {
    token = JSON.parse(token);
    setCookie(AUTH_COOKIE, token.token, 10 * 365 * 24 * 60 * 60);
    return token.token;
  }

  return token;
};

const initialAuth = fromJS({
  authToken: getToken(),
  authUser: null,
  errors: {},
  initUrl: null,
  email: null,
  alias: null,
});

const authReducer = (state = initialAuth, action) => {
  switch (action.type) {
    case SET_AUTH_DATA:
    case SIGNIN_USER_SUCCESS:
      return state
        .set('authToken', action.data ? action.data.token : null)
        .set('alias', action.data ? action.data.alias : null);
    case SIGNIN_USER_ERROR:
      return state.set('errors', fromJS(action.errors));
    case SIGNOUT_USER_SUCCESS:
      return state.merge(
        fromJS({
          authToken: '',
          authUser: null,
          errors: [],
        }),
      );
    case UPDATE_USER_SUCCESS:
    case UPDATE_CLIENT_USER_SUCCESS:
    case SET_AUTH_USER: {
      let newState = state;
      if (!state.get('authUser') || action.user.userId === state.getIn(['authUser', 'userId'])) {
        newState = newState.set('authUser', fromJS(action.user));
        if (action.alias) {
          newState = newState.set('alias', action.alias);
        }
      }
      return newState;
    }
    case DISCONNECT_TELEGRAM_SUCCESS: {
      if (action.userId !== state.getIn(['authUser', 'userId'])) {
        return state;
      }

      return state.setIn(['authUser', 'isTelegramConnected'], false);
    }
    case INIT_URL:
      return state.set('initUrl', action.url);
    case RESET_PASSWORD_SUCCESS:
      return state.set('email', action.email).set('errors', initialAuth.get('errors'));
    case RESET_PASSWORD_ERROR:
      return state.set('errors', fromJS(action.errors));
    case UPDATE_USER_COMPANY_SUCCESS:
      return state.setIn(
        ['authUser', 'companySettings'],
        fromJS({
          language: action?.company?.language,
          currency: action?.company?.currency,
          timezone: action?.company?.timezone,
          title: action?.company?.name,
        }),
      );
    default:
      return state;
  }
};

export default authReducer;
